import React from 'react';
import { useSite } from '../../context/SiteContext';
import { motion } from 'framer-motion';

export const ReviewsSection = () => {
  const { reviews } = useSite();

  if (!reviews?.length) return null;

  return (
    <section className="mx-auto max-w-7xl px-4 pb-16" id="reviews">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="rounded-3xl border border-slate-200 bg-white shadow-lg p-7 md:p-10"
      >
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-slate-900">
          Customer Reviews
        </h2>
        <p className="mt-4 text-slate-600 leading-relaxed">
          See what our customers are saying about their experience.
        </p>

        <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-4">
          {reviews.map((review, index) => (
            <motion.div
              key={review.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="rounded-2xl border border-slate-200 p-6 bg-slate-50 hover:shadow-lg transition-shadow"
              data-testid={`review-card-${index}`}
            >
              <div className="flex items-center justify-between">
                <div className="font-heading font-bold">{review.name}</div>
                {review.verified && (
                  <div className="text-xs text-green-600 font-semibold bg-green-100 px-2 py-1 rounded">
                    Verified purchase
                  </div>
                )}
              </div>
              <div className="mt-3 text-sm text-slate-600 italic font-display">
                "{review.text}"
              </div>
              <div className="mt-3 text-xs text-slate-500">{review.location}</div>
            </motion.div>
          ))}
        </div>

        <div className="mt-8 rounded-2xl border border-slate-200 bg-white p-6">
          <div className="font-heading font-bold">Important note</div>
          <div className="mt-2 text-sm text-slate-600">
            These are testimonials from real customers. Individual results may vary. This product is
            not intended to diagnose, treat, cure, or prevent any disease.
          </div>
        </div>
      </motion.div>
    </section>
  );
};

export default ReviewsSection;
